<h2 mat-dialog-title>{{ data.title || 'Bekræft' }}</h2>
<mat-dialog-content>
  <p>{{ data.message || 'Vil du fortsætte?' }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ data.cancelText || 'Annuller' }}</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">{{ data.confirmText || 'Ja' }}</button>
</mat-dialog-actions>
